import React from 'react';
import { FaPlus, FaMousePointer, FaTimes } from 'react-icons/fa';
import './MobileActionButtons.scss';

interface MobileActionButtonsProps {
  showSelection: boolean;
  selectedItemsCount: number;
  onCreateItem: () => void;
  onToggleSelection: () => void;
  onDeleteSelection?: () => void;
}

const MobileActionButtons: React.FC<MobileActionButtonsProps> = ({
  showSelection,
  selectedItemsCount,
  onCreateItem,
  onToggleSelection,
  onDeleteSelection,
}) => {
  return (
    <div className="mobile-action-buttons-container">
      <div className="mobile-action-buttons">
        <button className="mp-btn-primary" onClick={onCreateItem} title="Crear item">
          <FaPlus />
        </button>

        <button className="mp-toolbar-btn" onClick={onToggleSelection} title={showSelection ? "Cancelar selección" : "Seleccionar items"}>
          {showSelection ? <FaTimes /> : <FaMousePointer />}
        </button>

        {showSelection && selectedItemsCount > 0 && onDeleteSelection && (
          <button className="mp-btn-danger" onClick={onDeleteSelection} title={`Eliminar ${selectedItemsCount} items seleccionados`}>
            Eliminar ({selectedItemsCount})
          </button>
        )}
      </div>
    </div>
  );
};

export default MobileActionButtons;